import React from 'react';

const PermissionPage = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
      Permission Page
    </div>
  );
};

export default PermissionPage;
